import { apiGet } from '@/api/http';

import type { Role } from '@/types/reference';

const api_url = import.meta.env.VITE_API_URL;

export const getRolesList = () => apiGet<Role[]>(`${api_url}candidate-roles/`);
